// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1641":"marcos-legales-especificos-herramientas-list","3571":"marcos-legales-especificos-list","6310":"matriz-legal","7594":"about","8447":"marcos-legales-generales-versiones-list"}[chunkId] + "." + {"1641":"21f4dd08","3571":"21f4dd08","6310":"09f53e41","7594":"11a52b49","8447":"21f4dd08"}[chunkId] + ".css";
};